export const COLUMN_DEFAULT_WIDTH = 207 as const